<template>
  <div id="menu">
    <div id="app_menu" class="admin" :class="menuActive ? 'active' : ''">
      <div class="items">
        <ul>
          <li
            @click="menuActive = false"
            v-for="(item, index) in items"
            :key="index"
            :class="{ active: isActive(item.url) }"
          >
            <a
              :class="item.name === 'Benvenuto' ? 'benvenuto' : ''"
              :href="item.url"
              class="size-09"
            >
              <span>
                {{ item.name }}
                <strong
                  class="text-capitalize"
                  v-if="item.name === 'Benvenuto' && user.loaded"
                  >{{ user.name }}</strong
                >
              </span>

<!--              <div v-if="item.name === 'Benvenuto'" class="mail">-->
<!--                <i class="far fa-envelope"></i>-->
<!--                <div-->
<!--                  v-if="msgNr > 0"-->
<!--                  class="-->
<!--                    bg-red-->
<!--                    d-flex-->
<!--                    align-items-center-->
<!--                    justify-content-center-->
<!--                  "-->
<!--                >-->
<!--                  <span>{{ msgNr }}</span>-->
<!--                </div>-->
<!--              </div>-->
            </a>
          </li>

          <!-- logout -->
          <li class="red">
            <a class="size-09 pointer" @click="logout()">
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="logo">
        <img :src="logo" />
      </div>
    </div>
    <div
      @click="menuActive = !menuActive"
      class="hamburger"
      :style="
        menuActive
          ? 'left: calc(var(--admin-menu-width) + 20px);'
          : 'left: 20px;'
      "
    >
      <i v-if="!menuActive" class="fas fa-bars"></i>
      <i v-else class="fas fa-times"></i>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      msgNr: 0,
      menuActive: false,
      user: {},
      logo: window.location.origin + "/media/logo_4belt.png",
      items: [
        {
          name: "Benvenuto",
          rules: "",
          url: window.location.origin + "/admin/messages",
        },

        {
          name: "Dashboard",
          rules: "",
          url: window.location.origin + "/admin",
        },
        {
          name: "Clienti",
          rules: "",
          url: window.location.origin + "/admin/customers",
        },
        // {
        //   name: "Spedizioni",
        //   rules: "",
        //   url: window.location.origin + "/admin/shipping-areas",
        // },
        // {
        //   name: "Promozioni",
        //   rules: "",
        //   url: window.location.origin + "/admin/promotions",
        // },
        // {
        //   name: "Utilizzo promozioni",
        //   rules: "",
        //   url: window.location.origin + "/admin/promo-usages",
        // },
        {
          name: "Impostazioni B2B",
          rules: "",
          url: window.location.origin + "/admin/settings",
        },
        {
          name: "Moduli - Articolo",
          rules: "",
          url: window.location.origin + "/admin/mod-articolo",
        },
        {
          name: "Ordinamento Entità",
          rules: "",
          url: window.location.origin + "/admin/ordinamento",
        },
        {
          name: "Immagini articoli",
          rules: "",
          url: window.location.origin + "/admin/images",
        },
        {
          name: "Area Download",
          rules: "",
          url: window.location.origin + "/admin/downloads",
        },
        {
          name: "Sincronizzazione",
          rules: "",
          url: window.location.origin + "/admin/updating-sync",
        },
        {
          name: "Traduzioni",
          rules: "",
          url: window.location.origin + "/admin/translations",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("getUserName");
    this.$store.watch(
      (state) => state.user.loaded,
      (value) => {
        if (value) {
          this.user = this.$store.state.user;
          //console.log(this.user);
        }
      }
    );

    this.$store.dispatch("getMessages");
    this.$store.watch(
      (state) => state.msgLoaded,
      (value) => {
        if (value) {
          var newSugg = this.$store.state.suggerimenti.filter(
            (element) => element.letto === 0
          );
          // console.log(newSugg);
          var newCont = this.$store.state.contatti.filter(
            (element) => element.letto === 0
          );
          this.msgNr = newSugg.length + newCont.length;
          // console.log(this.msgNr);
        }
      }
    );
  },

  methods: {
    // getUserName: function () {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/getUserName",
    //   })
    //     .then((res) => {
    //       if (res.data.success) {
    //         this.userLoaded = true;
    //         this.userName = res.data.data.username;
    //       } else {
    //         console.log("no");
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error.response.data);
    //     });
    // },

    isActive: function (url) {
      return window.location.href == url;
    },

    logout: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/logout",
      })
        .then((res) => {
          if (res.data.url) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => {
          vue.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        })
        .then(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.hamburger {
  position: absolute;
  top: 15px;
  .fa-times {
    display: none;
  }
}

#app_menu.admin {
  display: none;
  &.active {
    display: flex;
  }
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
#app_menu.admin div.items,
#app_menu.admin div.logo {
  width: 100%;
}
.logo {
  position: relative;
  height: 50px;
  margin-bottom: 20px;
}
.logo img {
  margin: auto;
  display: block;
  height: 100%;
  width: auto;
}
ul {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul li {
  width: 100%;
  position: relative;
  border-bottom: 1px solid white;
  border-top: 1px solid white;
}
ul li {
  margin-top: -1px;
}
ul li.active,
ul li:hover {
  border-top-color: var(--green);
  border-bottom-color: var(--green);
  z-index: 2;
}
ul li a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.2em 1em;
  transition: all 0.3s linear;
  &.benvenuto {
    justify-content: space-between;
    .mail {
      font-size: 25px;
      position: relative;
      .bg-red {
        position: absolute;
        right: -8px;
        top: -2px;
        background-color: var(--red);
        border-radius: 50%;
        width: 18px;
        height: 18px;

        span {
          font-size: 10px;
          color: #fff;
        }
      }
    }
  }
}
ul li:hover a,
ul li.active a {
  background-color: var(--green);
  color: var(--black);
  padding-left: 1.5em;
}
/* logout style */
ul li.red:hover {
  border-top-color: var(--red);
  border-bottom-color: var(--red);
  z-index: 2;
}
ul li.red:hover a {
  background-color: var(--red);
  color: white;
}

@media (min-width: 576px) {
  .hamburger {
    .fa-times {
      display: block;
    }
  }
}

@media (min-width: 1200px) {
  #app_menu.admin {
    display: flex;
  }
  .hamburger {
    display: none;
  }
}
</style>
